import * as React from 'react'

import { CmsComponentSlot } from '@grandvisionhq/bloomreach'
import { Cart, CartSidebarSlotsProvider, VoucherCodesLayout } from '@grandvisionhq/carts-v2'
import { LoaderScreen, SupportFooter } from '@grandvisionhq/common'
import { Container } from '@grandvisionhq/elements'
import { NextPage } from '@grandvisionhq/next'
import { DeliveryIndicatorProvider } from '@grandvisionhq/shipping'
import { ReduxPersistGate, StoreWithPersistor, useIntl } from '@grandvisionhq/state'
import { compose } from '@grandvisionhq/utils'

import { withCms, withLayout } from '../../cms'
import { withCart } from '../../components/hocs/with-cart'
import { getDeliveryIndicatorConfig } from '../../configuration'

const deliveryIndicatorConfig = getDeliveryIndicatorConfig()

type Props = {
  store?: StoreWithPersistor
}

const CartPage: NextPage<Props> = ({ store }) => {
  const { getLabel } = useIntl()

  if (!store?.persistor) {
    console.error('Missing redux persistor')
    return null
  }

  return (
    <>
      <CmsComponentSlot path="main/top-container" />
      <ReduxPersistGate loading={<LoaderScreen />} persistor={store.persistor}>
        <DeliveryIndicatorProvider config={deliveryIndicatorConfig}>
          <CartSidebarSlotsProvider
            slots={{
              SecondComponent: VoucherCodesLayout,
            }}
          >
            <Container className="cart-layout">
              <Cart />
              <SupportFooter
                message={getLabel('support.title')}
                phoneNumber={getLabel('support.phoneNumber')}
                email={getLabel('support.emailAddress')}
              />
            </Container>
          </CartSidebarSlotsProvider>
        </DeliveryIndicatorProvider>
      </ReduxPersistGate>
      <CmsComponentSlot path="main/bottom-container" />
    </>
  )
}

export default compose(withCms(), withLayout({ navigation: false }), withCart())(CartPage)
